import script from "./species-filter.vue?vue&type=script&setup=true&lang=ts"
export * from "./species-filter.vue?vue&type=script&setup=true&lang=ts"

import "./species-filter.vue?vue&type=style&index=0&id=03052b88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03052b88"]])

export default __exports__